/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Error_ReadInputs */



/**
* | output |
* | --- |
* | "Error reading file." |
*
* @param {Alarms_Import_Error_ReadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_import_error_read = /** @type {((inputs?: Alarms_Import_Error_ReadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Error_ReadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Error reading file.")
	return /** @type {LocalizedString} */ ("Erreur lors de la lecture du fichier.")
});